import React, { FC, ReactNode } from 'react';
import cls from 'classnames';

import SlickCarousel from 'react-slick';
import 'slick-carousel/slick/slick.css';

import { CarouselProps, CarouselVariant } from './Carousel.types';
import ButtonIcon from '../../button/buttonIcon/ButtonIcon';
import { ButtonIconVariant } from '../../button/buttonIcon/ButtonIcon.types';
import { CaretLeftIcon, CaretRightIcon, IconProps } from '@stashinvest/react-assets';

export interface CustomArrowProps {
	Icon: FC<IconProps>;
	variant: ButtonIconVariant;
	onClick?: () => void;
}

const CustomArrow: FC<CustomArrowProps> = (props) => {
	const { Icon, variant, ...slickProps } = props;
	const isEnabled = Boolean(props.onClick);

	return (
		<div {...slickProps}>
			<ButtonIcon variant={variant} Icon={Icon} isEnabled={isEnabled} />
		</div>
	);
};

const Carousel: FC<CarouselProps> & { Variant: typeof CarouselVariant } = (props) => {
	const {
		children,
		onLargeGrid = false,
		hasGutter = true,
		hasBackground = true,
		variant = CarouselVariant.Background,
		className,
	} = props;

	const arrowVariant =
		variant === CarouselVariant.Inverse ? 'inverseSecondary' : 'secondary';

	const carouselProps = {
		infinite: false,
		arrows: onLargeGrid,
		draggable: !onLargeGrid,
		slidesToScroll: 1,
		slidesToShow: 1,
		prevArrow: <CustomArrow Icon={CaretLeftIcon} variant={arrowVariant} />,
		nextArrow: <CustomArrow Icon={CaretRightIcon} variant={arrowVariant} />,
		dotsClass: cls('slick-dots', {
			hasBackground,
		}),
		appendDots: (dots: ReactNode) => <ul>{dots}</ul>,
		customPaging: () => <></>,
		dots: true,
	};

	return (
		<div className={cls('carousel', { hasGutter }, variant, className)}>
			<SlickCarousel {...carouselProps}>{children}</SlickCarousel>
		</div>
	);
};

Carousel.displayName = 'Carousel';
Carousel.Variant = CarouselVariant;

export default Carousel;

/* function CaretLeft() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.5302 18.9694C15.5999 19.039 15.6552 19.1218 15.6929 19.2128C15.7306 19.3039 15.75 19.4014 15.75 19.5C15.75 19.5985 15.7306 19.6961 15.6929 19.7872C15.6552 19.8782 15.5999 19.9609 15.5302 20.0306C15.4606 20.1003 15.3778 20.1556 15.2868 20.1933C15.1957 20.231 15.0982 20.2504 14.9996 20.2504C14.9011 20.2504 14.8035 20.231 14.7124 20.1933C14.6214 20.1556 14.5387 20.1003 14.469 20.0306L6.96899 12.5306C6.89926 12.461 6.84394 12.3782 6.80619 12.2872C6.76845 12.1961 6.74902 12.0986 6.74902 12C6.74902 11.9014 6.76845 11.8038 6.80619 11.7128C6.84394 11.6217 6.89926 11.539 6.96899 11.4694L14.469 3.96936C14.6097 3.82863 14.8006 3.74957 14.9996 3.74957C15.1986 3.74957 15.3895 3.82863 15.5302 3.96936C15.671 4.1101 15.75 4.30097 15.75 4.49999C15.75 4.69901 15.671 4.88988 15.5302 5.03061L8.55993 12L15.5302 18.9694Z"
				fill="currentColor"
			/>
		</svg>
	);
}
function CaretRight() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M17.031 12.5306L9.53104 20.0306C9.46136 20.1003 9.37863 20.1556 9.28759 20.1933C9.19654 20.231 9.09896 20.2504 9.00042 20.2504C8.90187 20.2504 8.80429 20.231 8.71324 20.1933C8.6222 20.1556 8.53947 20.1003 8.46979 20.0306C8.40011 19.9609 8.34483 19.8782 8.30712 19.7872C8.26941 19.6961 8.25 19.5985 8.25 19.5C8.25 19.4014 8.26941 19.3039 8.30712 19.2128C8.34483 19.1218 8.40011 19.039 8.46979 18.9694L15.4401 12L8.46979 5.03061C8.32906 4.88988 8.25 4.69901 8.25 4.49999C8.25 4.30097 8.32906 4.1101 8.46979 3.96936C8.61052 3.82863 8.80139 3.74957 9.00042 3.74957C9.19944 3.74957 9.39031 3.82863 9.53104 3.96936L17.031 11.4694C17.1008 11.539 17.1561 11.6217 17.1938 11.7128C17.2316 11.8038 17.251 11.9014 17.251 12C17.251 12.0986 17.2316 12.1961 17.1938 12.2872C17.1561 12.3782 17.1008 12.461 17.031 12.5306Z"
				fill="currentColor"
			/>
		</svg>
	);
} */
